import {inject, Injectable, signal} from '@angular/core';
import {Role} from '@models/user.interface';
import {SubscriptionService} from '@services/subscription.service';
import {UserStateService} from '@services/frontend/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class ExecutiveSubscriptionState {
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly userStateService = inject(UserStateService);

  readonly loaded = signal(false);
  readonly hasProSubscription = signal(false);

  private loadStarted = false;

  ensureLoaded(): void {
    if (this.loadStarted) {
      return;
    }
    this.loadStarted = true;

    const role = this.userStateService.getUser()()?.role;
    if (role !== Role.EXECUTIVE) {
      this.hasProSubscription.set(true);
      this.loaded.set(true);
      return;
    }

    this.subscriptionService.checkSubscription().subscribe({
      next: (status) => {
        this.hasProSubscription.set(status.subscribed);
        this.loaded.set(true);
      },
      error: () => this.loaded.set(true),
    });
  }

  isFreeExecutive(): boolean {
    const user = this.userStateService.getUser()();
    if (user?.role !== Role.EXECUTIVE) {
      return false;
    }
    if (!this.loaded()) {
      return true;
    }
    return !this.hasProSubscription();
  }
}
